import { Injectable } from '@angular/core';
import { ICustomersController } from '@utils/interfaces/controller';
import { CustomersApiService } from '@domain/infrastructure/api';
import { CustomerReniecResponse, ICompanyResponse, ICustomerResponse } from '@utils/interfaces/response';
import { Observable } from 'rxjs';
import { DocumentType } from '@domain/model/enums/document-type/document-type.enum';
import { IKbaQuestionsResponse } from '@utils/interfaces/response/kba-questions-response.interface';
import { IKbaStatusResponse } from '@utils/interfaces/response/kba-status-response.interface';
import { KbaAnswers } from '@utils/types/questions.type';
import { IAccountsCounterResponse } from '@utils/interfaces/response/accounts-counter-response.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomersFacade implements ICustomersController {
  constructor(private readonly api: CustomersApiService) {}

  answerKbaQuestions(kbaId: string, questions: KbaAnswers): Observable<IKbaStatusResponse> {
    return this.api.answerKbaQuestions(kbaId, questions);
  }

  fetchKbaQuestions(documentNumber: string, documentType: DocumentType): Observable<IKbaQuestionsResponse> {
    return this.api.fetchKbaQuestions(documentNumber, documentType);
  }

  fetchBlackList(documentNumber: string, documentType: DocumentType): Observable<boolean> {
    return this.api.fetchBlackList(documentNumber, documentType);
  }

  fetchAccountsCounter(): Observable<IAccountsCounterResponse> {
    return this.api.fetchAccountsCounter();
  }

  fetchCustomer(
    documentNumber: string,
    documentType: Exclude<DocumentType, DocumentType.RUC>
  ): Observable<ICustomerResponse> {
    return this.api.fetchCustomer(documentNumber, documentType);
  }

  fetchCompany(ruc: string): Observable<ICompanyResponse> {
    return this.api.fetchCompany(ruc);
  }

  fetchLegalRepresentative(ruc: string, legalRepresentantNumber: string): Observable<CustomerReniecResponse> {
    return this.api.fetchLegalRepresentative(ruc, legalRepresentantNumber);
  }

  fetchReniecData(documentNumber: string) {
    return this.api.fetchReniecData(documentNumber);
  }

  createBussinessAccount(personAccount: any) {
    return this.api.createBussinessAccount(personAccount);
  }

  getCorrelationStatus(correlationId: string){
    return this.api.getCorrelationStatus(correlationId)
  }


}
